// @ts-check
import { assignmentActions } from './actions'
import { assignmentGetters } from './getters'
import { assignmentMutations } from './mutations'
import { initAssignmentState } from './state'

export { assignmentActions, assignmentGetters, assignmentMutations }

export const assignmentModule = {
  namespaced: true,
  state: initAssignmentState,
  getters: assignmentGetters,
  mutations: assignmentMutations,
  actions: assignmentActions
}

export default assignmentModule
